<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: {
    defaultValue: {
      type: Object,
      default: () => {}
    },
    products: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      submitData: {
        city: '',
        district: '',
        address: '',
      },
      addressRestrictions: [],
      enableSaveAddress: false,
    }
  },
  computed: {
    isEditMode() {
      return !!this.defaultValue.id
    },
    filterCities(){
      if (this.isEditMode) return this.addressRestrictions

      const cities = this.products.find((item )=> {
        return item.id === this.submitData.productId
      }).addressRestrictions
      return cities
    },
    districts() {
      if(!this.submitData.city) return []
      
      const city = this.filterCities.find(item=>{
        return this.submitData.city === item.city
      })

      return city === undefined ? [] : city.district
    },
    submitRules() {
      return {
        city: [{
          required: true,
          message: '請選擇縣市'
        }],
        district: [{
          required: true,
          message: '請選擇區域'
        }],
        address: [{
          required: true,
          message: '請輸入服務地址',
          trigger: 'blur'
        }],
      }
    },
  },
  watch: {
    defaultValue: {
      handler(val) {
        this.submitData = cloneDeep(val)
      },
      immediate: true,
    },
  },
  created() {
    if(this.isEditMode)
      this.tryToGetFilterCities()
  },
  methods: {
    async tryToGetFilterCities(){
      const { addressRestrictions } = await this.$store.dispatch('product/fetchSingle', this.defaultValue.productId)
      this.addressRestrictions = addressRestrictions
    },
    async onClickStore(){
      await this.$refs.form.validate()
      this.updateAddress()
    },
    onSelectCity() {
      this.submitData.district = ''
    },
    updateAddress() {
      this.$emit('update', {
        syncAddress: this.enableSaveAddress,
        data: this.submitData
      })
    },
    onClickClose() {
      this.$emit('close')
    }
  },
}
</script>
<template>
  <div :class="$style.orderformSection">
    <div class="orderformSection__right__header">
      <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="onClickClose"><i class="el-dialog__close el-icon el-icon-close"></i></button>
      <h4 class="orderformSection__right__title">編輯到府地址</h4>
    </div>
    <div class="orderformSection__right__content">
      <div>
        <el-form ref="form" class="el-form-item--white-bg" :rules="submitRules" :model="submitData">
          <el-row :gutter="20">
            <el-col :md="12">
              <el-form-item prop="city" label="縣市">
                <el-select v-model="submitData.city" filterable placeholder="請選擇" @change="onSelectCity">
                  <el-option v-for="(city, index) in filterCities" :key="index" :label="city.city" :value="city.city"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item prop="district" label="區域">
                <el-select v-model="submitData.district" placeholder="請選擇" filterable>
                  <el-option v-for="(district, index) in districts" :key="index" :label="district" :value="district"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-form-item prop="address" label="地址">
                <el-input v-model="submitData.address" placeholder="地址" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-checkbox v-if="!isEditMode" v-model="enableSaveAddress" style="margin-bottom: 20px">儲存到客戶地址</el-checkbox>
        </el-form>
        <div class="btn-group-inline" style="padding: 30px 0 50px">
          <el-button plain class="is-round" @click="onClickClose">取消</el-button>
          <el-button class="is-round" type="primary" :loading="loading" @click="onClickStore">儲存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>

.orderformSection {
  :global {
    .orderformSection {
      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;
        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }
        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;
          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }
          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }
          .el-tabs__nav-wrap::after {
            display: none;
          }
          .el-tabs__header {
            margin-bottom: 0;
          }
          .el-tabs--top {
            margin-left: 60px;
            @include max-lg {
              margin-left: 30px;
            }
          }
        }
        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;
          @include max-lg {
            padding: 20px;
          }
        }
      }
    }
  }
}
</style>